import request from '@/utils/request'

// 查询轮播图分页
export function getSearchKeywordList(query) {
  return request({
    url: '/shop/shop-express/search-keyword/' + query,
    method: 'get'
  })
}